// Countries without states (e.g. AT/DE/FR) store the "N/A" state, so it is treated the same as no state.
export function sanitizeLocationPart(value: string | null | undefined): string {
  const trimmedValue = (value ?? '').trim()
  if (!trimmedValue) {
    return ''
  }

  const normalizedValue = trimmedValue.toUpperCase()
  if (normalizedValue === 'N/A' || normalizedValue === 'NA') {
    return ''
  }

  return trimmedValue
}

export function sanitizeRegionValue(value: string | null | undefined): string {
  const sanitizedValue = sanitizeLocationPart(value)
  if (!sanitizedValue) {
    return ''
  }

  if (/^\d+$/.test(sanitizedValue)) {
    return ''
  }

  return sanitizedValue
}

export function formatCityRegion(city: string | null | undefined, region: string | null | undefined): string {
  const sanitizedCity = sanitizeLocationPart(city)
  const sanitizedRegion = sanitizeLocationPart(region)

  if (sanitizedCity && sanitizedRegion) {
    return `${sanitizedCity}, ${sanitizedRegion}`
  }

  return sanitizedCity || sanitizedRegion
}

export function formatConsultantLocation(consultant: { city?: string | null, region?: string | null } | null | undefined): string {
  return formatCityRegion(consultant?.city, sanitizeRegionValue(consultant?.region))
}
